<main-content-holder>
  <div>
    <h2 class="center-align"
        i18n="Support|Support page title@@support-page-title">Need Some Help?</h2>

    <h3 class="full-width center-align">
      <mat-spinner *ngIf="inProgress" color="primary" diameter="30" class="center"></mat-spinner>
      <div *ngIf="showHostSupport">
        <ng-container i18n="Support|Support page tenant details@@support-page-tenant-details">
          In case you have any questions regarding the contest, registrations, results, payments, access, etc., please get in touch with the host(s) via email at:
        </ng-container>

        <ul *ngIf="hosts" class="left-align">
          <li *ngFor="let host of hosts">
            <span class="mat-body-strong">{{host.firstName || ''}} {{host.lastName || ''}} &nbsp;</span>
            <span>(&nbsp;<app-link [href]="'mailto:' + host.email"
                                   class="link"
                                   [label]="host.email"
                                   [external]="true"></app-link>)</span>
          </li>
        </ul>
      </div>

      <mat-divider *ngIf="showHostSupport" class="full-width divider"></mat-divider>

      <ng-container i18n="Support|Support page details@@support-page-details">
        If you have any questions regarding the QuizWin platform, please get in touch with support at
      </ng-container>

      <app-link [href]="supportEmail"
                class="link"
                [label]="supportEmailLabel"
                [external]="true"></app-link>
    </h3>

    <div *ngIf="showSignIn" class="footer center-align">
      <ng-container i18n="Password Reset|Back to Sign In prompt@@password-reset-back-to-sign-in-prompt">Back to
      </ng-container>
      <app-link [routerLink]="signInUrl"
                label="Sign In"
                i18n-label="Password Reset|Back to Sign In link label@@password-reset-back-to-sign-in-link-label"
                class="link"></app-link>
    </div>
  </div>
</main-content-holder>
